import { useMemo } from 'react';
import type { Permission } from '@alltrails/types/Permission';
import type { User } from '@alltrails/types/User';
import useUser from './useUser';

export const userHasPermission = (user: User | null, permission: Permission) => {
  if (user?.permissions?.includes(permission)) {
    return true;
  }

  // Fall back to legacy admin check.
  return Boolean(user?.admin);
};

type HasPermissionArgs = {
  permission: Permission;
};

export default function useAuthorization() {
  const user = useUser();

  return useMemo(() => {
    return {
      hasPermission: ({ permission }: HasPermissionArgs) => {
        return userHasPermission(user, permission);
      }
    };
  }, [user]);
}
